function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  // "Set your password": forced after the first login and after a reset, or chosen from the account menu
  changePassword: path(ROOTS_AUTH, '/change-password'),
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  overview: path(ROOTS_DASHBOARD, '/overview'),
  clients: {
    root: path(ROOTS_DASHBOARD, '/clients'),
    all: path(ROOTS_DASHBOARD, '/clients/all'),
    active: path(ROOTS_DASHBOARD, '/clients/active'),
    trial: path(ROOTS_DASHBOARD, '/clients/trial'),
    expired: path(ROOTS_DASHBOARD, '/clients/expired'),
    blocked: path(ROOTS_DASHBOARD, '/clients/blocked'),
    deleted: path(ROOTS_DASHBOARD, '/clients/deleted'),
    details: (id: string | number) => path(ROOTS_DASHBOARD, `/clients/${id}`),
  },
  plansAndSubscriptions: {
    root: path(ROOTS_DASHBOARD, '/plans'),
    plans: path(ROOTS_DASHBOARD, '/plans'),
    subscriptions: path(ROOTS_DASHBOARD, '/subscriptions'),
    trialSettings: path(ROOTS_DASHBOARD, '/trial-settings'),
  },
  agents: {
    root: path(ROOTS_DASHBOARD, '/agents'),
    all: path(ROOTS_DASHBOARD, '/agents/all'),
    active: path(ROOTS_DASHBOARD, '/agents/active'),
    inactive: path(ROOTS_DASHBOARD, '/agents/inactive'),
    deleted: path(ROOTS_DASHBOARD, '/agents/deleted'),
    details: (id: string | number) => path(ROOTS_DASHBOARD, `/agents/${id}`),
  },
  websiteLeads: {
    root: path(ROOTS_DASHBOARD, '/leads'),
    queries: path(ROOTS_DASHBOARD, '/leads/queries'),
    partnerRequests: path(ROOTS_DASHBOARD, '/leads/partner-requests'),
  },
  voterSigns: {
    root: path(ROOTS_DASHBOARD, '/voter-signs'),
  },
  pollingSchedules: {
    root: path(ROOTS_DASHBOARD, '/polling-schedules'),
  },
  locations: {
    root: path(ROOTS_DASHBOARD, '/locations'),
  },
  partners: {
    root: path(ROOTS_DASHBOARD, '/partners'),
    all: path(ROOTS_DASHBOARD, '/partners/all'),
    pending: path(ROOTS_DASHBOARD, '/partners/pending'),
    approved: path(ROOTS_DASHBOARD, '/partners/approved'),
    rejected: path(ROOTS_DASHBOARD, '/partners/rejected'),
    suspended: path(ROOTS_DASHBOARD, '/partners/suspended'),
    deleted: path(ROOTS_DASHBOARD, '/partners/deleted'),
    details: (id: string) => path(ROOTS_DASHBOARD, `/partners/${id}`),
    orders: path(ROOTS_DASHBOARD, '/partner-orders'),
    locationRequests: path(ROOTS_DASHBOARD, '/partners/location-requests'),
  },
  commissions: {
    root: path(ROOTS_DASHBOARD, '/commissions'),
    settings: path(ROOTS_DASHBOARD, '/commissions/settings'),
    rules: path(ROOTS_DASHBOARD, '/commissions/rules'),
    ledger: path(ROOTS_DASHBOARD, '/commissions/ledger'),
    payouts: path(ROOTS_DASHBOARD, '/commissions/payouts'),
    unconfigured: path(ROOTS_DASHBOARD, '/commissions/unconfigured'),
    reports: path(ROOTS_DASHBOARD, '/commissions/reports'),
  },
  kyc: {
    root: path(ROOTS_DASHBOARD, '/kyc'),
    settings: path(ROOTS_DASHBOARD, '/kyc/settings'),
    queue: path(ROOTS_DASHBOARD, '/kyc/queue'),
    review: (partnerId: string) => path(ROOTS_DASHBOARD, `/kyc/review/${partnerId}`),
  },
  wallets: {
    root: path(ROOTS_DASHBOARD, '/wallets'),
    overview: path(ROOTS_DASHBOARD, '/wallets/overview'),
    all: path(ROOTS_DASHBOARD, '/wallets/all'),
    recharges: path(ROOTS_DASHBOARD, '/wallets/recharges'),
    reconcile: path(ROOTS_DASHBOARD, '/wallets/reconcile'),
    settings: path(ROOTS_DASHBOARD, '/wallets/settings'),
    partnerWallet: (id: string) => path(ROOTS_DASHBOARD, `/wallets/partners/${id}`),
  },
  material: {
    root: path(ROOTS_DASHBOARD, '/material'),
    orders: path(ROOTS_DASHBOARD, '/material/orders'),
    orderDetails: (id: string) => path(ROOTS_DASHBOARD, `/material/orders/${id}`),
    products: path(ROOTS_DASHBOARD, '/material/products'),
    settings: path(ROOTS_DASHBOARD, '/material/settings'),
    postcards: path(ROOTS_DASHBOARD, '/material/postcards'),
    stuck: path(ROOTS_DASHBOARD, '/material/stuck'),
    reports: path(ROOTS_DASHBOARD, '/material/reports'),
    slipData: path(ROOTS_DASHBOARD, '/material/slip-data'),
  },
  uploadRequests: {
    root: path(ROOTS_DASHBOARD, '/upload-requests'),
    details: (id: string) => path(ROOTS_DASHBOARD, `/upload-requests/${id}`),
  },
  announcements: {
    root: path(ROOTS_DASHBOARD, '/announcements'),
    create: path(ROOTS_DASHBOARD, '/announcements/new'),
  },
  promoCodes: {
    root: path(ROOTS_DASHBOARD, '/promo-codes'),
    all: path(ROOTS_DASHBOARD, '/promo-codes/all'),
    expired: path(ROOTS_DASHBOARD, '/promo-codes/expired'),
    partnerCodeSettings: path(ROOTS_DASHBOARD, '/promo-codes/partner-code-settings'),
  },
  paymentsAndInvoices: {
    root: path(ROOTS_DASHBOARD, '/payments'),
    all: path(ROOTS_DASHBOARD, '/payments/all'),
    successful: path(ROOTS_DASHBOARD, '/payments/successful'),
    pending: path(ROOTS_DASHBOARD, '/payments/pending'),
    failed: path(ROOTS_DASHBOARD, '/payments/failed'),
    invoices: path(ROOTS_DASHBOARD, '/invoices'),
  },
  settings: {
    socialPlatforms: path(ROOTS_DASHBOARD, '/settings/social-platforms'),
  },
  notifications: path(ROOTS_DASHBOARD, '/notifications'),
};
